import { defaultIconColor } from './constants';
import { SVGComponentPropsType } from './types';

const defaultSize = 24;

export default ({ color = defaultIconColor, size = defaultSize, ...props }: SVGComponentPropsType) => (
  <svg
    width={size}
    height={size}
    viewBox={`0 0 ${defaultSize} ${defaultSize}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="19" cy="5" r="2" stroke={color} strokeWidth="2" />
    <circle cx="11" cy="12" r="2" stroke={color} strokeWidth="2" />
    <circle cx="5" cy="5" r="2" stroke={color} strokeWidth="2" />
    <circle cx="5" cy="19" r="2" stroke={color} strokeWidth="2" />
    <circle cx="19" cy="19" r="2" stroke={color} strokeWidth="2" />
    <path d="M5 7v10M7 5h10m-5 8 6 5M7 19h10m1-13-6 5" stroke={color} strokeWidth="2" />
  </svg>
);
